import type {NuxtApp} from "#app";
import type {TokenStorage} from "@/node_modules/nuxt-laravel-echo/dist/runtime/types/config";

const tokenStorageKey = 'echo.storage.token';
const localTokenStorage: TokenStorage = {
    get: async () => {
        if (import.meta.server) {
            return undefined;
        }

        return window.localStorage.getItem(tokenStorageKey) ?? undefined;
    },

    set: async (app: NuxtApp, token?: string) => {
        if (import.meta.server) {
            return;
        }

        if (!token) {
            window.localStorage.removeItem(tokenStorageKey);
            return;
        }

        window.localStorage.setItem(tokenStorageKey, token);
    },
};

export default defineAppConfig({
    nuxtQuasar: {
        notify: {
            color: 'primary',
            group: false
        }
    },
    sanctum: {
        tokenStorage: localTokenStorage
    },
    echo: {
        tokenStorage: localTokenStorage
    }
})